<!--
 * @Description: 
 * @Date: 2022-05-24 10:57:37
-->
<template>
  <div class="to-settlement">
    <div style="text-align: center">
      <table-render
        ref="tableRender"
        :config="config"
        height="45vh"
        :setPageSize="60"
        width="80vw"
      />
    </div>
    <div style="text-align:center">
      <div style="margin-top:20px">
        <el-button type="primary" @click="close">关闭</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import tableRender from '@/components/tableRender';
import { orderManagement } from '@/api/ajax';
export default {
  components: { tableRender },
  props: {
    param: Object
  },
  computed: {
    config() {
      const arr = [
        {
          name: '查看批次',
          childMenu: [
            {
              list: orderManagement.remarkDesc,
              defaultQuery: {
                ...this.param
              },
              requestNow: true,
              fields: [
                {
                  label: '项目名称',
                  prop: 'projectName'
                },
                {
                  label: '工业方',
                  prop: 'industryName'
                },
                {
                  label: '项目人数',
                  key: 'personNum',
                  prop: 'personNum'
                }
              ]
            }
          ]
        }
      ];
      let col = arr[0].childMenu[0].fields;
      if (this.param.priceType == 2 || this.param.priceType == 6) {
        arr[0].childMenu[0].fields = col.filter(
          item => item.key != 'personNum'
        );
      }
      return arr;
    }
  },
  methods: {
    close() {
      this.$xrkDialog.remove();
    }
  }
};
</script>

<style scoped lang="scss">
.to-settlement {
  width: 70vw;
}
.tableHeader th {
  // color: red !important;
  font-weight: 800;
  background-color: #fbfbfb !important;
}
</style>
